const EXPERIMENT_COOKIE = "pl_exp"
const MAX_COOKIE_LENGTH = 2048
const MAX_ASSIGNMENTS = 20
const ASSIGNMENT_PART = /^[A-Za-z0-9_-]{1,64}$/

export function parseExperimentAssignments(cookie = document.cookie): Record<string, string> {
    const raw = cookie
        .split(";")
        .map((part) => part.trim())
        .find((part) => part.startsWith(`${EXPERIMENT_COOKIE}=`))
        ?.slice(EXPERIMENT_COOKIE.length + 1)

    if (!raw || raw.length > MAX_COOKIE_LENGTH) return {}

    let decoded: string
    try {
        decoded = decodeURIComponent(raw)
    } catch {
        return {}
    }

    if (decoded.length > MAX_COOKIE_LENGTH) return {}

    const assignments: Record<string, string> = {}
    for (const pair of decoded.split(",")) {
        if (Object.keys(assignments).length >= MAX_ASSIGNMENTS) break

        const separator = pair.indexOf(":")
        if (separator <= 0 || separator === pair.length - 1) continue

        const key = pair.slice(0, separator)
        const variant = pair.slice(separator + 1)
        if (!ASSIGNMENT_PART.test(key) || !ASSIGNMENT_PART.test(variant)) continue

        assignments[key] ??= variant
    }

    return assignments
}

export function getInitialExperimentProperties(cookie = document.cookie): Record<string, string> {
    return Object.fromEntries(
        Object.entries(parseExperimentAssignments(cookie)).map(([key, variant]) => [
            `initial_exp_${key}`,
            variant,
        ]),
    )
}
